import React, { useState } from "react";
import { Row, Col, Button } from "reactstrap";
import { PlayerCard } from "../../components/card";
import GameData from "../../components/gameData";
import x from "../../assets/images/GAH/x.png";
import _ from "lodash";
import Alert from "../../components/shared/common/alert";
import { connect } from "react-redux";
import cx from "classnames";
import { removeUser } from "../../components/shared/utils";
import Socket from "../../socket/socket";

import avatar from "../../assets/images/avatar.svg";
import Cross from "../../assets/images/verboden/cross.png";
// import callTone from "../../assets/sounds/incoming-call copy.mp3";

class Player extends React.Component {
  constructor(props) {
    super(props);
    const gameName = props.gameReducer.gameName;
    this.state = {
      allusers: [],
      audioUrl: "",
      how_to_play: false,
      blur: false,
      rating: { value: "Adult (R)", label: "Adult (R)" },
      round: gameName && gameName !== "" && gameName === "GAH" ? 4 : 10
    };
  }

  handleChangeNew = (selectedOption) => {
    this.setState({ rating: selectedOption, blur: false });
  };
  handelBlur = () => {
    this.setState({ blur: true });
  };
  handelBlurOut = () => {
    this.setState({ blur: false });
  };
  handleAddOrSubtractRound = (key, isGAH) => {
    let max_round = 12;
    if (isGAH) {
      max_round = 7;
    }
    const state = this.state;
    let currentRound = state.round;
    const roomObj = this.props.gameReducer.roomObj;

    if (key === "add") {
      if (state.round >= 0) {
        if (currentRound >= max_round) {
          Alert(200, `Max rounds can be ${max_round} only`);
          return;
        } else {
          currentRound = parseInt(currentRound) + 1;
          this.setState({ round: currentRound });
        }
      }
    } else {
      if (state.round > 0) {
        currentRound = currentRound - 1;
        if (currentRound <= 1) {
          currentRound = 1;
          this.setState({ round: 1 });
        } else {
          this.setState({ round: currentRound });
        }
      }
    }

    let data = {
      action: "update-lobby-options",
      roomId: roomObj.id,
      rounds: currentRound
    };
    Socket.sendMessage(data);
  };
  componentDidMount() {
    let roomObj = this.props.gameReducer.roomObj;
  }

  static comparer = (otherArray) => {
    return function (current) {
      return (
        otherArray.filter(function (other) {
          return other.player_id === current.player_id;
        }).length === 0
      );
    };
  };

  componentDidUpdate() {
    let roomObj = this.props.gameReducer.roomObj;

    if (
      this.props.usersChanged &&
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length > 0
    ) {
      if (roomObj.users.length > this.state.allusers.length) {
        const callAudioEl = document.getElementById("callAudio");
        let result = roomObj.users.filter(Player.comparer(this.state.allusers));
        this.setState(
          {
            allusers: roomObj.users,
            audioUrl:
              result && result[0] && result[0].audio_effect
                ? result[0].audio_effect
                : ""
          },
          () => {
            if (callAudioEl) {
              callAudioEl
                .play()
                .then(() => {})
                .catch(() => {});
              setTimeout(() => {
                callAudioEl.pause();
                callAudioEl.currentTime = 0;
              }, 3000);
            }
          }
        );
      }
    }
    if (
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length < this.state.allusers.length
    ) {
      this.setState({
        allusers: roomObj.users
      });
    }
  }

  delPlayer = (data) => {
    const roomObj = this.props.gameReducer.roomObj;
    removeUser(roomObj, data);
  };

  render() {
    const roomObj = this.props.gameReducer.roomObj;
    const { type = "", className = "" } = this.props;

    let maxPlayerText = "* Max 10 Players";
    let gameParamText = "Game Parameters";
    let backButtonText = "BACK";
    let startButtonText = "START";
    let playerLabel = "Players";

    if (this.props.paramsReducer && this.props.paramsReducer.gameObj) {
      let gameObj = this.props.paramsReducer.gameObj;

      if (gameObj && gameObj.screens && gameObj.screens.lobby) {
        maxPlayerText = gameObj.screens.lobby.max_players_label;
        gameParamText = gameObj.screens.lobby.label;
        playerLabel = gameObj.screens.lobby.player_label.toLocaleLowerCase();
        startButtonText = gameObj.screens.lobby.button_text;
      }
    }
    const allusers = roomObj.users;
    let getActiveUsers = roomObj.users;
    // if(allusers && allusers.length >0){

    //   getActiveUsers = allusers.filter((user) => user.active === true);

    // }
    const usersList = _.uniqBy(getActiveUsers, "user_id").filter(
      (i) => !!i.user_id
    );

    return (
      <>
        {type === "GAH" ? (
          <div className={`h-100 ${type === "GAH" ? "GAH-player-border" : ""}`}>
            {this.state.how_to_play ? (
              <div className="howToPlayModal">
                <div className="headerHTP">
                  <h2> How To Play </h2>
                  <button
                    className="deleteBtn"
                    onClick={() =>
                      this.setState({ ...this.state, how_to_play: false })
                    }
                  >
                    <img src={x} />
                  </button>
                </div>
                <div className="Main-textHTP">
                  <div className="textHTP">
                    <ul>
                      <li>
                        {" "}
                        The Judge starts the round by flipping and reading a
                        prompt card out loud.
                      </li>

                      <li>
                        {" "}
                        Each player selects a Play card via their phone that
                        they feel pairs the best with the Prompt card.
                      </li>

                      <li>
                        Once everyone has submitted their cards, the Judge hits
                        the button on their phone to flip them over.{" "}
                      </li>

                      <li>
                        {" "}
                        The Judge picks whichever card (or GIF!) they find to be
                        funniest and the player who played it scores!{" "}
                      </li>

                      <li>
                        {" "}
                        The winning player advances everyone to the next round
                        via the button that appears on their phone, and a new
                        player becomes the Judge.
                      </li>

                      <li>
                        Play continues until someone gets enough points to win.
                        (Score To Win is selected in game lobby before the game
                        begins)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={cx(
                  "bg-g-theme l-6  h-100 lobby-card player pb-3 GAH-card",
                  className
                )}
              >
                {/* <button className="howToPlaybtn" onClick={() => this.setState({ ...this.state, how_to_play: true })}>
                  How To Play
                </button> */}
                <div className="gah-players-how-play">
                  <audio
                    key={this.state.users}
                    id="callAudio"
                    src={this.state.audioUrl}
                  ></audio>
                  <div className="">
                    <p
                      className="text title mb-0"
                      style={{ textTransform: "capitalize" }}
                    >
                      {playerLabel} ({usersList.length}/10)
                      {/* <span>{maxPlayerText}</span> */}
                    </p>
                    {/* <p className="text title">Total : {usersList.length}/10</p> */}
                  </div>
                  <button
                    className="howToPlaybtn"
                    onClick={() =>
                      this.setState({ ...this.state, how_to_play: true })
                    }
                  >
                    How To Play
                  </button>
                </div>

                {/* <audio key={this.state.users} id="callAudio" src={this.state.audioUrl}></audio> */}
                {/* <div className="d-flex justify-content-between">
                  <p className="text title">
                    {playerLabel} ({usersList.length}/10) */}
                {/* <span>{maxPlayerText}</span> */}
                {/* </p>
                  
                </div> */}
                {/* <p className="text title">Total : {usersList.length}/10</p> */}

                <div>
                  <div className="playerRow ">
                    <Row className="mx-0">
                      {usersList &&
                        usersList.length > 0 &&
                        usersList.map((data, index) => (
                          <Col key={index} lg={6} sm={6}>
                            <PlayerCard
                              {...data}
                              key={index}
                              roomData={roomObj}
                              delPlayer={this.delPlayer}
                            />
                          </Col>
                        ))}
                      {/* <Col lg={12}>
                      <div className="gah-players-wrapper">
                        <div className="players-wrapper">
                          <div className="gah-players-box">
                            <img src={avatar} className="gah-player-image" />
                            <h3 className="gah-player-name">Player</h3>
                            <Button color="gahTheme" className="cross-btn">
                              <img src={Cross} alt="cross" />
                            </Button>
                          </div>
                          <div className="gah-players-box">
                            <img src={avatar} className="gah-player-image" />
                            <h3 className="gah-player-name">Player</h3>
                            <Button color="gahTheme" className="cross-btn">
                              <img src={Cross} alt="cross" />
                            </Button>
                          </div>
                          <div className="gah-players-box">
                            <img src={avatar} className="gah-player-image" />
                            <h3 className="gah-player-name">Player</h3>
                            <Button color="gahTheme" className="cross-btn">
                              <img src={Cross} alt="cross" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Col> */}
                    </Row>
                  </div>
                  <GameData
                    onBack={this.props.onBack}
                    gameParamText={gameParamText}
                    backButtonText={backButtonText}
                    startButtonText={startButtonText}
                    round={this.state.round}
                    onAddOrSubtractRound={this.handleAddOrSubtractRound}
                    blur={this.state.blur}
                    rating={this.state.rating}
                    onChangeNew={this.handleChangeNew}
                    onBlur={this.handelBlur}
                    onBlurOut={this.handelBlurOut}
                  />
                </div>
              </div>
            )}
          </div>
        ) : (
          <>
            <div className={`h-100 ${type === "TW" ? "tw" : ""}`}>
              <div
                className={cx(
                  "bg-g-theme l-6  h-100 lobby-card lobby-twcard player pb-3",
                  className
                )}
              >
                <audio
                  key={this.state.users}
                  id="callAudio"
                  src={this.state.audioUrl}
                ></audio>
                <p className="text-total text-right title">
                  Total : {usersList.length}
                </p>
                <div className="d-flex justify-content-center align-items-center flex-column">
                  <p
                    className="text title"
                    style={{ textTransform: "capitalize" }}
                  >
                    {playerLabel}
                    {/* Players */}
                  </p>
                  {/* <p className="sub-text">{maxPlayerText}</p> */}
                  <p className="sub-text">({usersList.length}/10)</p>
                </div>
                <div>
                  <div className="playerRow">
                    <Row className="mx-0 tw-player-row">
                      {usersList &&
                        usersList.length > 0 &&
                        usersList.map((data, index) => (
                          <Col key={index} lg={6}>
                            <PlayerCard
                              className="lg"
                              {...data}
                              key={index}
                              roomData={roomObj}
                              delPlayer={this.delPlayer}
                            />
                          </Col>
                        ))}
                    </Row>
                  </div>
                  <GameData
                    onBack={this.props.onBack}
                    gameParamText={gameParamText}
                    backButtonText={backButtonText}
                    startButtonText={startButtonText}
                    round={this.state.round}
                    onAddOrSubtractRound={this.handleAddOrSubtractRound}
                    blur={this.state.blur}
                    rating={this.state.rating}
                    onChangeNew={this.handleChangeNew}
                    onBlur={this.handelBlur}
                    onBlurOut={this.handelBlurOut}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});

export default connect(mapStateToProps, null)(Player);
